<template>
  <TableColumn
    :label="column.name"
    :prop="column.key"
    :min-width="column.minWidth || 150"
    :sortable="column.sortable ? 'custom' : false"
  >
    <template slot-scope="scope">
      <slot
        name="column"
        :data="{
          field: column,
          row: scope.row,
          value: scope.row[column.key]
        }"
      />
    </template>
    
    <template v-for="item in column.children">
      <DynamicTableColumn
        v-if="item.children && item.children.length"
        :key="item.key"
        :coloumn="item"
      />
      <TableColumn
        v-else
        :key="item.key"
        :label="item.name"
        :prop="item.key"
        :min-width="item.minWidth || 150"
        :sortable="item.sortable ? 'custom' : false"
      >
        <!-- <template
          v-if="item.filterable"
          slot="header"
        >
          <span>{{ item.name }}</span>
          <div class="column-filter">
            <TableFilter
              :type="item.key"
              @change="handleTableFilterChange"
            />
          </div>
        </template> -->
  
        <template slot-scope="scope">
          <slot
            name="column"
            :data="{
              field: item,
              row: scope.row,
              value: scope.row[item.key]
            }"
          />
        </template>
      </TableColumn>
    </template>
  </TableColumn>
</template>

<script>
import { TableColumn } from 'element-ui';

import TableFilter from '../TableFilter/Index';

export default {
  name: 'DynamicTableColumn',

  components: {
    TableColumn,

    TableFilter,
  },

  props: {
    column: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },

  methods: {
    handleTableFilterChange(filters) {
      this.$emit('filter-change', filters);
    },
  },
};
</script>

<style lang="less" scoped>
.column-filter {
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translate(0, -50%);
}
</style>